import React from "react";
import { Box, styled, List, SxProps, Theme } from "@mui/material";

export type MenuBaseProps = {
    children: React.ReactNode,
    width?: number | string,
    boxShadow?: number | string,
    borderRight?: number | string,
    sx?: SxProps<Theme>
    footer?: React.ReactNode
}

const StyledNav = styled(List)({
    '& .MuiListItemButton-root': {
        paddingLeft: 24,
        paddingRight: 24,
    },
    '& .MuiListItemIcon-root': {
        minWidth: 0,
        marginRight: 16,
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20,
    },
});
export function Menu({ children, width = 200, boxShadow = 5, borderRight = "1.2px solid", footer, sx }: MenuBaseProps) {
    return (
        <Box sx={{
            display: "flex",
            width: width,
            boxShadow: boxShadow,
            borderRight: borderRight,
            borderColor: '#99989877',
            flexDirection: "column",
            justifyContent: "space-between",
            ...sx
        }}
        >
            <StyledNav>
                {children}
            </StyledNav>
            {footer}
        </Box>
    );
}

export default Menu;